import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../model/model'

export const selectWorklistFilters = (state: RootState) =>
	state.worklist.worklistFilters

export const selectCurrentPaginationPage = (state: RootState) =>
	state.worklist.currentPaginationPage

export const selectWorklistPaginationPages = (state: RootState) =>
	state.worklist.paginationTotalPages

export const selectResultsToSkip = createSelector(
	selectCurrentPaginationPage,
	currentPaginationPage => (currentPaginationPage - 1) * 10,
)

export const selectStatusFilters = createSelector(
	selectWorklistFilters,
	({ status }) => status,
)
